@import 'apps/webcomponents/src/assets/common.scss';
@import 'apps/webcomponents/src/assets/style-helpers.scss';
@import 'apps/webcomponents/src/assets/text-helpers.scss';
@import 'apps/webcomponents/src/assets/color-helpers.scss';
@import 'apps/webcomponents/src/xdr/sensors/base/styles/common.scss';

gz-radio-group {
  width: 100%;

  gz-radio {
    margin-bottom: 0;
  }
}

p {
  font-size: var(--body-size-large);
  color: var(--main-titles-inputs-600)
}

.separator {
  &:after {
    content: "";
    display: block;
    width: 100%;
    height: 1px;
    background: var(--chart-101-pressed-dividers);
  }
}
